meedy.factory('meedy.vacationService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, baseService, objectHelper, config) {

        function VacationService() {

            this.getUserVacations = function () {
                return baseService.get(config.API_URL + '/vacations/getUserVacations').then(
                    function (successResponse) {
                        var data = objectHelper.translateArray(successResponse, VacationMeedyVO);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createUserVacation = function (vacation) {
                vacation = objectHelper.convertDatesToTimes(vacation);
                return baseService.post(config.API_URL + '/vacations/createUserVacation', vacation).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, VacationMeedyVO);
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteVacation = function (idVacation) {
                return baseService.post(config.API_URL + '/vacations/deleteVacation', idVacation).then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.checkCollisions = function(vacation) {
                vacation = objectHelper.convertDatesToTimes(vacation);
                return baseService.post(config.API_URL + '/vacations/checkCollisions', vacation).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new VacationService();
    }
]);
